import { IconsConstants, SharedConstants } from 'src/app/shared/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconSvgComponent } from '../icon/svg-icon.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalStorageHelper } from '../../helper/local-storage-helper';

@Component({
  selector: 'app-table-header',
  standalone: true,
  imports: [CommonModule, IconSvgComponent, TranslateModule],
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss'],
})
export class TableHeaderComponent implements OnInit {
  isToggleActive: boolean = false;

  @Output() colorToggleChange: EventEmitter<boolean> = new EventEmitter();
  //constnts
  IconsConstants = IconsConstants;
  SharedConstants = SharedConstants;
  constructor() {
    this.onActivateTableColors();
  }

  ngOnInit(): void {}

  // public
  onClickToggle(): void {
    this.isToggleActive = !this.isToggleActive;
    this.colorToggleChange.emit(this.isToggleActive);
  }

  private onActivateTableColors(): void {
    this.isToggleActive = LocalStorageHelper.getItem(SharedConstants.LOCAL_STORAGE_TABLE_COLORS_KEY) === 'true' ? true : false;
  }
}
